import { LoadingOverlay } from "@/features/shared/components/Loaders"
import { isDevEmail } from "@/features/shared/utils/devAccess"
import { useUserStore } from "@/utils/stores/useUserStore"
import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"

const RequireDevAccess = ({ children }: { children: React.ReactNode }) => {
    const navigate = useNavigate()
    const email = useUserStore((state) => state.userData?.email)
    const [isChecking, setIsChecking] = useState(true);

    const isDev = email && isDevEmail(email);

    useEffect(() => {
        if (!isDev) {
            navigate('/', { replace: true });
        } else {
            setIsChecking(false);
        }
    }, [email, isDev, navigate]);

    if (isChecking) return <LoadingOverlay />

    return <>{children}</>;
}

export default RequireDevAccess
